<template>
  <div class="Records">
    <v-container class="mt-5">
      <RecordsTable :records="records" />
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RecordsTable from "@/components/table/RecordsTable";

export default {
  name: "Records",
  components: {
    RecordsTable,
  },
  methods: {
    ...mapActions({
      loadRecordsByMinDuration: "records/loadRecordsByMinDuration",
    }),
  },
  mounted() {
    this.loadRecordsByMinDuration(123);
    this.sockets.subscribe("CREATE_RECORD_IN_TABLE", () => {});
  },
  computed: {
    ...mapGetters({
      records: "records/records",
    }),
  },
};
</script>

<style scoped>
</style>